import { render, staticRenderFns } from "./Cancelled.vue?vue&type=template&id=15c38ace&scoped=true&"
import script from "./Cancelled.vue?vue&type=script&lang=js&"
export * from "./Cancelled.vue?vue&type=script&lang=js&"
import style0 from "./Cancelled.vue?vue&type=style&index=0&id=15c38ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c38ace",
  null
  
)

export default component.exports